import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DateFilterService {
  private dateFilter = new BehaviorSubject<DateFilter>(init);

  getFilter() {
    return this.dateFilter;
  }

  getValue() {
    return this.dateFilter.getValue();
  }

  setFilter(filter: any) {
    this.dateFilter.next(filter);
  }

  resetFilter() {
    this.dateFilter.next(init);
  }
}

export interface DateFilter {
  dateType: string;
  startDate: Date;
  endDate: Date;
}

export const init: DateFilter = {
  dateType: 'any',
  startDate: new Date(new Date().setHours(0, 0, 0, 0)),
  endDate: new Date(new Date().setHours(0, 0, 0, 0)),
};
